<template>
  <div class="basket-drop-down" v-click-outside="close">
    <div class="basket-header">
      Basket
    </div>
    <div class="basket-body">
      <div
        class="d-flex basket-product"
        v-for="product in products"
        :key="product.id"
      >
        <div
          class="mr-4 d-flex align-center baset-product-image-container col-3"
        >
          <v-carousel
            hide-delimiters
            cycle
            height="50"
            v-model="carousel"
            :show-arrows="false"
            v-if="product.images.length > 0"
          >
            <v-carousel-item
              v-for="image in product.images"
              :key="image.id"
              :src="image.imageUrl"
            >
            </v-carousel-item>
          </v-carousel>
          <v-carousel
            hide-delimiters
            :show-arrows="false"
            height="50"
            v-model="carousel"
            v-else
          >
            <v-carousel-item
              src="https://i.stack.imgur.com/y9DpT.jpg"
            ></v-carousel-item>
          </v-carousel>
        </div>
        <div class="flex">
          <div>
            <h3 class="basket-product-name">
              {{ product.name.substr(0, 15) }}...
            </h3>
          </div>
          <div class="d-flex align-center justify-space-between">
            <div class="d-flex align-center">
              <v-btn
                class="ml-0 mr-2 counter-button-negative"
                icon
                outlined
                plain
                small
                tile
                @click="popFromBasket(product)"
              >
                <v-icon dark>
                  mdi-minus
                </v-icon>
              </v-btn>
              <span class="basket-product-quantity mr-2">{{
                product.quantity
              }}</span>
              <v-btn
                class="ml-0 counter-button-plus"
                color="appRed"
                plain
                small
                tile
                elevation="0"
                @click="addToBasket(product)"
              >
                <v-icon dark>
                  mdi-plus
                </v-icon>
              </v-btn>
            </div>
            <div class="d-flex align-end">
              <span class="appRed--text basket-product-price mr-1">
                {{ product.amount }}
              </span>
              <v-btn
                @click="removeFromBasket(product)"
                text
                tile
                elevation="0"
                class="pa-0 ma-0 h-25"
              >
                <v-icon large color="appDarkGrey" class="delete-basket-icon"
                  >mdi-delete-outline
                </v-icon>
              </v-btn>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-2 checkout-details">
        <div class="d-flex justify-space-between mb-5">
          <div class="price-label">Sub Total</div>
          <div class="flex border-underscore"></div>
          <div class="total-price">£{{ subTotal }}</div>
        </div>
        <div class="d-flex justify-space-between mb-5">
          <div class="price-label">Shipping</div>
          <div class="flex border-underscore"></div>
          <div class="total-price">£{{ shippingTotal }}</div>
        </div>
        <div class="d-flex justify-space-between">
          <div class="price-label">Total</div>
          <div class="flex border-underscore"></div>
          <div class="total-price">£{{ total }}</div>
        </div>
      </div>
      <div>
        <v-btn
        v-if="products.length > 0"
          class="ml-0 gotham-medium white--text font-weight-bold text-capitalize checkout-btn"
          color="appRed"
          block
          @click="loadCheckout"
        >
          checkout
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>
import vClickOutside from "v-click-outside";
import { mapState } from "vuex";
export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      carousel: 0
    };
  },
  computed: {
    ...mapState({
      products: state => state.product.basketProducts
    }),
    subTotal() {
      return this.products
        .reduce((a, b) => a + b.quantity * b.amount, 0)
        .toFixed(2);
    },
    shippingTotal() {
      return this.products.reduce((a, b) => a + b.shippingFee, 0).toFixed(2);
    },
    total() {
      return parseFloat(this.subTotal) + parseFloat(this.shippingTotal);
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    loadCheckout() {
      this.$router.push({ name: "Basket" });
      this.$emit("close");
    },
    addToBasket(product) {
      console.log(product)
      // this.evtPushProductToCart(product);
      this.$store.commit("product/ADD_ITEM_TO_BASKET", product);
    },
    popFromBasket(product) {
      console.log(product)
      // this.evtPopProductFromCart(product);
      this.$store.commit("product/POP_DISH_FROM_BASKET", product);
    },
    removeFromBasket(product) {
      // this.evtPopProductFromCart(product);
      this.$store.commit("product/REMOVE_PRODUCT_FROM_BASKET", product);
    }
  }
};
</script>
<style lang="scss" scoped src="./BasketDropDown.scss"></style>
